<template>
  <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
    <div data-template="template7" class="wrap-template template7"> <!--is_rang class casing font color dark when hover odds-->
      <div class="main-handicap">
        <div class="vrow items-center template-title is_fold">
          <div class="play-name col" @click="showLeg()">
            <span class="ellipsis">{{ getTitleCaption() }}{{ sportAllBetLang['ALL_BET.SUBHEADER_H1x2'] }}</span>
          </div>
          <div style="width: 37px;" @click="setToTop($event)">
            <span class="set_top" style="display: none;">
              <i data-v-082e727f="" aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
            </span>
          </div>
        </div>
        <template v-if="show">
          <div class="handicap m-1x2">
            <div class="handicap-item os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item" style="width:75%">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tacapt"></span>
                      </div>
                      <span class="bet_handicap yb-family-odds vhighlight">
                        {{ hdpTitle('h', newAllBetEvent) }}
                      </span>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamHome" :plyType="plytyp" :betType="bettyp" ref="team1" :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class="handicap-item os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item">
                      <div class="item-label bet-ellipsis ellipsis" style="width:30%">
                        <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}</span>
                      </div>
                      <span class="bet_handicap yb-family-odds vhighlight" style="display: flex;width: 52%;margin-left: 3px;" v-html="hdpTitle('x', newAllBetEvent)"></span>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamDraw" :plyType="plytyp" :betType="bettyp" ref="teamX" :mode="'ab'" />
                </div>
              </div>
            </div>
            <div class="handicap-item os-1">
              <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
                <div class="bet-inner yb-flex-center fit">
                  <div class="handicap-wrap">
                    <div class="bet-item" style="width:75%">
                      <div class="item-label bet-ellipsis ellipsis">
                        <span class="ellipsis-wrap" v-html="newAllBetEvent.tbcapt"></span>
                      </div>
                      <span class="bet_handicap yb-family-odds vhighlight">
                        {{ hdpTitle('a', newAllBetEvent) }}
                      </span>
                    </div>
                  </div>
                  <odd1x2 :event="newAllBetEvent" :team="teamAway" :plyType="plytyp" :betType="bettyp" ref="team2" :mode="'ab'" />
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd1x2'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    bettyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = 'FT'
      var b = ''
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H'
      }else if (this.plytyp == this.SecondHtPlyType) {
        a = '2H'
      }
      a =   this.sportAllBetLang['ALL_BET.SUBHEADER_' + a] ;
      // if (this.bettype == this.hdpBetType) {
   //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_HDP']
      // } else if (this.bettype == this.bttsBetType) {
      //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
      // }

      // RB score
      if (this.newAllBetEvent.event_rb == 1) {
        b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
      }
      return a
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, bettyp) {
      if (this.selectMarket)
        this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    removeFromMyMarket(plytyp, bettyp) {
      if (this.removeMarket)
        this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
    },
    oddsHeader() {
      var retCapt = ''
      if (this.isSpecial) {
        retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
      }

      return retCapt
    },
    hdpTitle(team, event) {
      var hdp = event.od[this.plytyp][this.bettyp]['hdp']
      if (team == 'h') {
        if (hdp > 0) {
          return " +" + parseInt(hdp)
        } else if (hdp < 0) {
          return parseInt(hdp)
        }
      } else if (team == 'a') {
        var newHdp = (parseInt(hdp) * -1)
        var awayHdp = ''

        if (newHdp > 0) {
          awayHdp = '+' + newHdp
        } else if (newHdp < 0) {
          awayHdp = newHdp
        }
        return awayHdp
      } else if (team == 'x') {
        if (hdp > 0) {
          // return this.sportAllBetLang['ALL_BET.LBL_HOME'] + " +" + parseInt(hdp)
          return "+" + parseInt(hdp)
        } else if (hdp < 0) {
          var newHdp = (parseInt(hdp) * -1)
          var awayHdp = ''

          if (newHdp > 0) {
            awayHdp = '+' + newHdp
          } else if (newHdp < 0) {
            awayHdp = newHdp
          }
          return '<div class="ellipsis">'+this.sportAllBetLang['ALL_BET.LBL_AWAY'] + '</div>&nbsp;' + awayHdp
        }
      }
    },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-h1x2.vue